import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import { LicenseManager } from  'ag-grid-enterprise';
import { MSALInstanceFactory } from './app/core.module';
 
 

if (environment.production) {
  enableProdMode();
}

LicenseManager.setLicenseKey("Using_this_{AG_Grid}_Enterprise_key_{AG-089504}_in_excess_of_the_licence_granted_is_not_permitted___Please_report_misuse_to_legal@ag-grid.com___For_help_with_changing_this_key_please_contact_info@ag-grid.com___{Uniper_IT_GmbH}_is_granted_a_{Multiple_Applications}_Developer_License_for_{2}_Front-End_JavaScript_developers___All_Front-End_JavaScript_developers_need_to_be_licensed_in_addition_to_the_ones_working_with_{AG_Grid}_Enterprise___This_key_has_not_been_granted_a_Deployment_License_Add-on___This_key_works_with_{AG_Grid}_Enterprise_versions_released_before_{18_April_2027}____[v3]_[01]_MTgwODAwMjgwMDAwMA==c0be4ef243ceb902868a7b0269d13cc0");


// platformBrowserDynamic().bootstrapModule(AppModule)
//   .catch(err => console.error(err));


async function bootstrap() {
  const msalInstance = MSALInstanceFactory();
  await msalInstance.initialize(); // 👈 This is crucial
  platformBrowserDynamic().bootstrapModule(AppModule)
    .catch(err => console.error(err));
}

bootstrap();

